/* eslint-disable react/button-has-type */
import { LoadingOutlined } from '@ant-design/icons';
import React, { ButtonHTMLAttributes } from 'react';
import { Typography } from 'tfc-components';

import Icon, { IconName, IconSize } from 'components/atoms/Icon';
import mapModifiers from 'utils/functions';

type TSize = 'p10x16' | 'p12' | 'p8x12' | 'p6x12' | 'p5x114';
type THeight = 'h40' | 'h32' | 'h44';
type TIconProps = {
  align: 'left' | 'right';
  size: IconSize;
  name: IconName
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  icon?: TIconProps;
  variant?: 'primary' | 'secondary' | 'outline' | 'icon' | 'transparent' | 'blue-crayola';
  modifiers?: (TSize | THeight)[];
  size?: 'p10x16' | 'p12' | 'p8x12',
  isLoading?: boolean,
  isFullWidth?: boolean,
  loadingColor?: string
}

const Button: React.FC<ButtonProps> = ({
  children, type = 'button', icon, variant, modifiers, isLoading, isFullWidth, loadingColor, className, size, ...props
}) => (
  <button
    type={type}
    className={`${mapModifiers('a-button', variant, modifiers && modifiers, isFullWidth && 'fullWidth', size)} ${className || ''}`}
    {...props}
  >
    {isLoading ? <LoadingOutlined width={20} style={{ color: loadingColor || (variant ? '#344054' : '#fff') }} /> : (
      <>
        {icon && icon.align === 'left' && <span className="a-button_icon-left"><Icon iconName={icon.name} size={icon.size} /></span>}
        {
          children && (
            <Typography.Text
              extendClasses="a-button_text"
            >
              {children}
            </Typography.Text>
          )
        }
        {icon && icon.align === 'right' && <span className="a-button_icon-right"><Icon iconName={icon.name} size={icon.size} /></span>}
      </>
    )}
  </button>
);

export default Button;
